import { STORE_STEP, CLEAR_STEPS, SET_ACTIVE_STEP } from '../constants/Constants';

export const stepReducer = (state : any = {steps : []}, action) => {
    switch (action.type) {
      case STORE_STEP:
      {
        return {
          ...state,
          steps : state.steps.concat({
            title : action.payload.title,
            formName : action.payload.formName
          })
        };
      }        
      case CLEAR_STEPS:
        return {
          activeStepFormName : "",
          steps : []
        };
      case SET_ACTIVE_STEP:
        return {
          ...state,
          activeStepFormName: action.payload.stepFormName
        };
      default:
        return state;
    }
};